import React from 'react';
import { WaitRing } from '../Icons';

interface WaitLineProps {
   active: boolean;
   label: string;
}

/**
 * The wait state: the concierge is looking through the hotel's pages. A slate line and a small ring whose
 * sky arc turns. Nothing bounces; reduced motion stops the arc.
 */
const WaitLine: React.FC<WaitLineProps> = ({ active, label }) => {
   if (!active) return null;
   return (
      <div className="cx-wait" role="status" aria-live="polite">
         <WaitRing className="cx-ring" />
         <span>{label}</span>
      </div>
   );
};

export default WaitLine;
